import { SCREENS } from '../../services/exports/Constants';
import { ButtonTypes, Order } from '../../services/exports/Interfaces';
import CustomModal from '../../components-library/CustomModal';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../components-library/buttons/CustomButton';
import { Modals } from '../../modules/mobile/exports/Enums';
import useMobileApp from '../../hooks/mobile-app/useMobileApp';
import WindowResource from '../../services/resources/WindowResource';

type Props = {
  open: boolean;
  order: Order;
  onConfirm: () => void;
  toggleModal: () => void;
};

const DuplicateOrderModal = (props: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:Checkout:DuplicateOrderModal' });

  const { open, order, onConfirm, toggleModal } = props;
  const { isMobileApp } = useMobileApp();

  const _onConfirm = () => {
    onConfirm();
    toggleModal();
  };

  return (
    <CustomModal open={open}>
      <div className="w-full flex flex-col p-lg">
        <p>{t('text')}</p>
        <div className="mt-lg flex justify-between">
          <CustomButton
            title={t('buttons.see_existing_order')}
            onClick={() => {
              if (isMobileApp) {
                return WindowResource.replace(
                  `${WindowResource.getOriginWithPathname()}?open_modal=${Modals.OrderTracker}&uuid=${order.uuid}&mobile_app=true`,
                );
              }

              WindowResource.replace(`${SCREENS.ORDER_DETAILS}/${order.uuid}`);
            }}
            className="mr-md p-sm"
            titleClass="text-sm"
          />
          <CustomButton
            title={t('buttons.proceed_new_order')}
            buttonType={ButtonTypes.forth}
            className="p-sm"
            titleClass="text-sm"
            onClick={_onConfirm}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default DuplicateOrderModal;
